// ResetPassword.js
import React, { useEffect, useState } from "react";
import "./pages.css";
import { useResetPasswordMutation } from "../store/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "../components/Button";

export function ResetPassword() {
	const location = useLocation();
	const email1 = location.state?.email || "";
	const [email, setEmail] = React.useState(email1);
	const [password, setPassword] = React.useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [errors, setErrors] = React.useState({ email: "", password: "", confirmPassword: "" });

	const [showPassword, setShowPassword] = React.useState(false);

	const [resetPassword] = useResetPasswordMutation();
	const [loading, setLoading] = useState(false); // NEW

	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		setEmail(email1);
	}, [email1]);

	const handleLogin = async () => {
		// Проверяем совпадают ли пароли
		if (password !== confirmPassword) {
			setErrors((prev) => ({ ...prev, confirmPassword: "Пароли не совпадают" }));
			return;
		}

		// Проверяем остальные ошибки
		if (errors.email || errors.password || !email || !password) return;

		try {
			setLoading(true); // NEW
			const response = await resetPassword({ email, password }).unwrap();
			alert("Ваш пароль успешно обновлен!");
			if (response.success) {
				navigate("/login", {
					state: {
						email: email
					}
				});
			}
		} catch (err) {
			console.error("Ошибка:", err);
		} finally {
			setLoading(false); // NEW
		}
	};

	const handleEmailChange = (e) => {
		const value = e.target.value;
		setEmail(value);
		if (!value) {
			setErrors((prev) => ({ ...prev, email: "Email обязателен" }));
		} else if (!/\S+@\S+\.\S+/.test(value)) {
			setErrors((prev) => ({ ...prev, email: "Неправильный формат email" }));
		} else {
			setErrors((prev) => ({ ...prev, email: "" }));
		}
	};

	const handleConfirmPasswordChange = (e) => {
		const value = e.target.value;
		setConfirmPassword(value);
		if (value !== password) {
			setErrors((prev) => ({ ...prev, confirmPassword: "Пароли не совпадают" }));
		} else {
			setErrors((prev) => ({ ...prev, confirmPassword: "" }));
		}
	};

	const handlePasswordChange = (e) => {
		const value = e.target.value;
		setPassword(value);
		if (!value) {
			setErrors((prev) => ({ ...prev, password: "Пароль обязателен" }));
		} else if (value.length <= 2) {
			setErrors((prev) => ({ ...prev, password: "Минимум 2 символов" }));
		} else {
			setErrors((prev) => ({ ...prev, password: "" }));
		}
	};

	return (
		<div className="login">
			<div className="login_form">
				<div className="login-form_top"></div>
				<div className="login-form_title">Сброс пароля</div>

				<div className="login-form_field">
					<div className="login-form_label">Email</div>
					<input
						className="login-form_inp"
						type="email"
						value={email}
						onChange={handleEmailChange}
						required
					/>
					{errors.email && <div className="error-text">{errors.email}</div>}
				</div>

				<div className="login-form_field">
					<div className="login-form_label">Пароль</div>
					<input
						className="login-form_inp"
						type={showPassword ? "text" : "password"}
						value={password}
						onChange={handlePasswordChange}
					/>
					{errors.password && <div className="error-text">{errors.password}</div>}
				</div>

				<div className="login-form_field">
					<div className="login-form_label">Повторите пароль</div>
					<input
						className="login-form_inp"
						type={showPassword ? "text" : "password"}
						value={confirmPassword}
						onChange={handleConfirmPasswordChange}
					/>
					{errors.confirmPassword && <div className="error-text">{errors.confirmPassword}</div>}
				</div>

				<div className="login-form_bottom">
					<Button onClick={handleLogin} disabled={loading}> {/* NEW */}
						{loading ? "Сбрасываем..." : "Сбросить"} {/* NEW */}
					</Button>
				</div>
			</div>

			<div className="login-img">
				<img src="/new-logo.jpg" alt="" />
			</div>
		</div>
	);
}

export default ResetPassword;
